angular
  .module('app', ['ui.router',
                  'slick',
                  'ngAnimate',
                  'ngResource',
                  'ngTouch',
                  'ngSanitize',
                  'ui.bootstrap',
                  'toastr',
                  'ngActionCable',
                  'ui.select',
                  'ngFileUpload',
                  'datePicker',
                  'thatisuday.dropzone',
                  'ngMask',
                  'ng.jsoneditor',
                  'chart.js',
                  'vcRecaptcha'
                ]);
